import { format } from 'date-fns';
import { DATE_FORMAT_COMPACT } from '@/shared/config';
import type { HistoryPageFilter } from '@/shared/types';

export const buildOperationsGetQueryParams = (filters: HistoryPageFilter) => {
  const formatDate = (date?: Date) =>
    date ? format(date, DATE_FORMAT_COMPACT) : undefined;

  if (filters.datefilter === 'custom') {
    return {
      datefilter: undefined,
      datefrom: formatDate(filters.datefrom),
      dateto: formatDate(filters.dateto),
    };
  }

  return {
    datefilter: filters.datefilter,
    datefrom: undefined,
    dateto: undefined,
  };
};
